import { InternalAccount as ControlAccount } from "gen/coa/models_pb"
import { useEnumFilter } from "shared-ts/hooks/useFilter"

import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"
import { Accounting } from "lib/accounting"

export function useControlAccountFilter({
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<UseWebFilterProps<unknown>, "persistInUrl" | "initialSelectedOptions">
> = {}) {
  return useEnumFilter({
    key: "control_accounts",
    label: "Control account",
    enumeration: ControlAccount,
    labelExtractor,
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      }),
  })
}

function labelExtractor(ca: ControlAccount) {
  return Accounting.INTERNAL_ACCOUNT_NAMES[ca] ?? ""
}
